import { render, staticRenderFns } from "./LeaveApply.vue?vue&type=template&id=10097da5&scoped=true"
import script from "./LeaveApply.vue?vue&type=script&lang=js"
export * from "./LeaveApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10097da5",
  null
  
)

export default component.exports